import React from 'react';
import { useTranslation } from 'react-i18next';
import HierarchyFieldBuilder from './fields/hierarchy-field/hierarchy-field-builder.component';
import { useAppDispatch } from '../../redux/hooks';
import { setSelectedGroupId } from '../../redux/slices/form-builder-slice';
import FormBuilderAccordion from './form-builder-accordion.component';

const FormBuilderHierarchy = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const onSectionClick = () => {
    dispatch(setSelectedGroupId('HIERARCHIES'));
  };

  return (
    <FormBuilderAccordion id="HIERARCHIES" caption={t('hierarchies')} onGroupClick={onSectionClick}>
      <HierarchyFieldBuilder />
    </FormBuilderAccordion>
  );
};

export default React.memo(FormBuilderHierarchy);
